import rmpModel from "./Models/RMP.flow";
import hllModel from "./Models/HLL.flow";
import rlModel from "./Models/RL.flow";
import rpgModel from "./Models/RPG.flow";
import rmgModel from "./Models/RMG.flow";

// Единый реестр моделей: используется страницей модели, меню в шапке и
// хлебными крошками, чтобы название нозологии нигде не задавалось руками.
export const models = {
    rmp: rmpModel,
    hll: hllModel,
    rl: rlModel,
    rpg: rpgModel,
    rmg: rmgModel,
}

export const modelList = Object.keys(models).map(key => ({key, name: models[key].name}))

export const modelName = key => models[key]?.name
